import * as React from 'react';
import { c as classNames, u as useEGDSContext } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-link.css';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';

const EGDSLinkThemeMap = [
    ['default', 'default'],
    ['inverse', 'inverse'],
];
const EGDSLinkThemes = new Map(EGDSLinkThemeMap);
const EGDSLinkSizeMap = [
    ['small', 'small'],
    ['medium', 'medium'],
    ['large', 'large'],
];
const EGDSLinkSizes = new Map(EGDSLinkSizeMap);
const EGDSLinkAlignMap = [
    ['left', 'left'],
    ['center', 'center'],
    ['right', 'right'],
];
const EGDSLinkAligns = new Map(EGDSLinkAlignMap);

/* eslint-disable no-useless-computed-key */
const getClassNameList = classNames.bind(styles);
const getDefaultSize = (props) => {
    const { inline } = props;
    return inline ? undefined : EGDSLinkSizes.get('medium');
};
const EGDSLink = (props) => {
    const { children, className, align = EGDSLinkAligns.get('left'), theme = EGDSLinkThemes.get('default'), inline = false, noWrap = false, analytics, disabled, domRef, ...attributes } = props;
    const { data: contextData } = useEGDSContext();
    const { contextClassNames } = contextData ?? {};
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    const size = props.size || getDefaultSize(props);
    const childClassName = getClassNameList('uitk-link', contextClassNames?.EGDSLink, className, {
        [`uitk-link-align-${align}`]: align,
        ['uitk-link-theme-inverse']: theme === 'inverse',
        ['uitk-link-no-wrap']: noWrap,
        ['uitk-link-layout-inline']: inline,
        ['uitk-link-layout-default']: !inline,
        [`uitk-link-${size}`]: size && EGDSLinkSizes.get(size),
        ['uitk-link-disabled']: !!disabled,
    });
    const linkChildren = firstChild.props.children;
    const linkIconClassName = getClassNameList(`uitk-link-icon-${size}`, {
        ['uitk-link-inverse-icon']: theme === 'inverse',
    });
    const newChildren = [];
    const isButton = firstChild?.type === 'button';
    const disabledButton = disabled && isButton;
    React.Children.map(linkChildren, (child) => {
        if (child?.type?.displayName?.match(/(EGDS|Uitk)Icon/)) {
            newChildren.push(React.cloneElement(child, {
                className: getClassNameList(linkIconClassName),
            }));
        }
        else {
            newChildren.push(child);
        }
    });
    const clickCaptureCallback = React.useCallback(() => {
        if (analytics) {
            return analyticsTracker(analytics);
        }
    }, [analytics]);
    const onClickCapture = firstChild.props.onClickCapture || props.onClickCapture || clickCaptureCallback;
    const decoratedChild = React.cloneElement(firstChild, {
        analytics,
        children: newChildren,
        ref: domRef,
        className: childClassName,
        ...attributes,
        onClickCapture,
        ...(disabledButton && {
            tabIndex: -1,
            disabled: true,
        }),
        ...(!isButton && {
            role: 'link',
            'aria-disabled': disabled || undefined, // 'undefined' fixes cursor bug
        }),
    });
    return decoratedChild;
};
EGDSLink.displayName = 'EGDSLink';

export { EGDSLink as E, EGDSLinkThemes as a, EGDSLinkSizes as b, EGDSLinkAligns as c };
//# sourceMappingURL=index-chunk.esm.js.map
